// Tessera fedelta' (Area Clienti) + Impostazioni piattaforma (Admin) — Fase 2.
import { api, unwrap } from './client';

export const walletService = {
  /** Portafoglio del cliente loggato (card, tier, punti, next tier). */
  getWallet: () => unwrap(api.get('/customer/wallet')),
  /** Movimenti punti. */
  getTransactions: (limit = 50) => unwrap(api.get('/customer/wallet/transactions', { params: { limit } })),
};

export const platformSettingsService = {
  /** Config economica globale (Admin). */
  get: () => unwrap(api.get('/admin/platform-settings')),
  /** Aggiorna la config (patch parziale). */
  update: (patch) => unwrap(api.put('/admin/platform-settings', patch)),
  /** Anteprima calcolo carrello (tutte le voci collegate). */
  cartPreview: (body) => unwrap(api.post('/admin/platform-settings/cart-preview', body)),
  /** Accredito manuale punti a un cliente (per email). */
  award: (body) => unwrap(api.post('/admin/platform-settings/award', body)),
};
